import React, { useState } from "react";
import { Modal, Pressable, View } from "react-native";
import CCText from "@/Atoms/CCText";

const TIME_CONTROLS = ["3+0", "5+0", "5+3", "10+0", "15+10"];

// Member sheet to post a game challenge into the club chat.
export default function CreateChallengeSheet({
  visible,
  onCancel,
  onCreate,
  submitting,
}: {
  visible: boolean;
  onCancel: () => void;
  onCreate: (timeControl: string, rated: boolean) => void;
  submitting?: boolean;
}) {
  const [tc, setTc] = useState("5+0");
  const [rated, setRated] = useState(true);

  const submit = () => {
    if (submitting) return;
    onCreate(tc, rated);
    setTc("5+0");
    setRated(true);
  };

  return (
    <Modal transparent animationType="fade" visible={visible} onRequestClose={onCancel}>
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(38,35,34,0.45)",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
        }}
      >
        <View
          testID="create-challenge-sheet"
          style={{ backgroundColor: "#FAF6EB", borderRadius: 18, padding: 20, width: "100%", maxWidth: 420 }}
        >
          <CCText fontWeight="thunder" style={{ fontSize: 22, color: "#262322", marginBottom: 14 }}>
            Post a challenge
          </CCText>

          <CCText style={{ fontSize: 12, fontWeight: "600", color: "#6B584D", marginBottom: 8 }}>
            Time control
          </CCText>
          <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}>
            {TIME_CONTROLS.map((t) => {
              const active = tc === t;
              return (
                <Pressable
                  key={t}
                  testID={`tc-${t}`}
                  onPress={() => setTc(t)}
                  style={{
                    paddingVertical: 8,
                    paddingHorizontal: 14,
                    borderRadius: 999,
                    backgroundColor: active ? "#3DAB9E" : "#fff",
                    borderWidth: active ? 0 : 1,
                    borderColor: "rgba(38,35,34,0.12)",
                  }}
                >
                  <CCText style={{ fontWeight: "600", color: active ? "#fff" : "#6B584D", fontSize: 13 }}>{t}</CCText>
                </Pressable>
              );
            })}
          </View>

          <Pressable
            testID="challenge-rated-toggle"
            onPress={() => setRated((r) => !r)}
            style={{ flexDirection: "row", alignItems: "center", gap: 10, marginTop: 16 }}
          >
            <View
              style={{
                width: 22,
                height: 22,
                borderRadius: 6,
                borderWidth: 2,
                borderColor: rated ? "#3DAB9E" : "#C9BFA8",
                backgroundColor: rated ? "#3DAB9E" : "transparent",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {rated ? <CCText style={{ color: "#fff", fontSize: 13, fontWeight: "700" }}>✓</CCText> : null}
            </View>
            <CCText style={{ fontSize: 14, color: "#262322" }}>Rated game</CCText>
          </Pressable>

          <View style={{ flexDirection: "row", gap: 10, marginTop: 18 }}>
            <Pressable
              testID="challenge-cancel-btn"
              onPress={onCancel}
              style={{ flex: 1, borderWidth: 1.5, borderColor: "#4D3F37", borderRadius: 10, paddingVertical: 12, alignItems: "center" }}
            >
              <CCText style={{ fontSize: 14, fontWeight: "600", color: "#4D3F37" }}>Cancel</CCText>
            </Pressable>
            <Pressable
              testID="challenge-post-btn"
              disabled={submitting}
              onPress={submit}
              style={{ flex: 1, backgroundColor: "#3DAB9E", borderRadius: 10, paddingVertical: 12, alignItems: "center" }}
            >
              <CCText style={{ fontSize: 14, fontWeight: "600", color: "#fff" }}>
                {submitting ? "Posting…" : "Post challenge"}
              </CCText>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
}
